module.exports = __webpack_public_path__ + "static/media/pizza-1200x480.81a23aa4.jpg";